module.exports = __webpack_public_path__ + "img/234-australia.901bbddb.svg";